import React,{Fragment,useState,useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {BrowserRouter as Router,Route,Redirect} from 'react-router-dom';
import { useHistory } from "react-router-dom";

import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';

import swal from 'sweetalert';
import axios from 'axios'
import {API_URL,APP_URL} from '../config.json'


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center" style={{textAlign:'center',fontWeight:'500',color:'#ffffff',fontStyle:'italic',
    fontSize: '13px', marginTop: '20px', textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'}}>
      {'Developed By  '}
      <Link color="inherit" target="_blank" href="https://smartcodesolutions.net" style={{color:'#ffffff', textDecoration: 'none', fontWeight: '600'}}>
        Smart Code Solutions ||
      </Link>{' '}
      Hotline : +923138426377
    </Typography>
  );
}


const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url("${API_URL}/uploads/login%20background.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    padding: '20px',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
      zIndex: 0,
    },
  },
  licenseKeyModal:{
    display: 'none',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '30px',
    backgroundColor: '#fff',
    border: 'none',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    textAlign: 'center',
    zIndex: 1000,
    minWidth: '380px',
    animation: '$slideIn 0.3s ease-out',
  },
  slideIn: {
    from: {
      opacity: 0,
      transform: 'translate(-50%, -60%)',
    },
    to: {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '50px 40px',
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
    borderRadius: '20px',
    boxShadow: '0 25px 80px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    minWidth: '420px',
    animation: '$fadeInUp 0.6s ease-out',
  },
  fadeInUp: {
    from: {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  avatar: {
    margin: theme.spacing(2),
    background: 'linear-gradient(135deg, #424C57 0%, #E32730 100%)',
    width: 70,
    height: 70,
    boxShadow: '0 8px 25px rgba(227, 39, 48, 0.3)',
  },
  title: {
    marginTop: theme.spacing(2),
    marginBottom: '5px',
    fontSize: '28px',
    fontWeight: '700',
    color: '#ffffff',
    textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
  },
  subtitle: {
    fontSize: '14px',
    color: '#f0f0f0',
    marginBottom: theme.spacing(3),
    fontWeight: '500',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      backgroundColor: 'rgba(245, 245, 250, 0.6)',
      '& fieldset': {
        borderColor: 'rgba(102, 126, 234, 0.2)',
        borderWidth: '1.5px',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(227, 39, 48, 0.5)',
        backgroundColor: 'rgba(245, 245, 250, 0.9)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#E32730',
        borderWidth: '2px',
        boxShadow: '0 0 0 4px rgba(227, 39, 48, 0.15)',
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
    },
    '& .MuiInputBase-input': {
      fontSize: '15px',
      fontWeight: '600',
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      caretColor: '#E32730 !important',
      backgroundColor: 'transparent !important',
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 1) inset !important',
        WebkitTextFillColor: '#000000 !important',
      },
      '&:-webkit-autofill:focus': {
        WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 1) inset !important',
        WebkitTextFillColor: '#000000 !important',
      },
      '&:focus': {
        color: '#000000 !important',
        WebkitTextFillColor: '#000000 !important',
        backgroundColor: 'rgba(255, 255, 255, 0.95) !important',
      },
      '&::placeholder': {
        color: '#999999',
        opacity: 0.8,
      },
    },
    '& .MuiFormLabel-root': {
      fontSize: '14px',
      color: '#666',
      fontWeight: '500',
      '&.Mui-focused': {
        color: '#E32730',
      },
    },
  },
  submit: {
    margin: theme.spacing(3.5, 0, 2),
    padding: '14px 30px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    background: 'linear-gradient(135deg, #424C57 0%, #E32730 100%)',
    color: '#fff !important',
    borderRadius: '10px',
    boxShadow: '0 6px 25px rgba(227, 39, 48, 0.4)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      background: 'linear-gradient(135deg, #E32730 0%, #424C57 100%)',
      boxShadow: '0 10px 35px rgba(227, 39, 48, 0.5)',
      transform: 'translateY(-2px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
      boxShadow: '0 4px 15px rgba(227, 39, 48, 0.2)',
    },
  },
  logoSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 15px 50px rgba(0, 0, 0, 0.2)',
    marginRight: '30px',
    minWidth: '280px',
    animation: '$fadeInLeft 0.6s ease-out 0.1s backwards',
  },
  fadeInLeft: {
    from: {
      opacity: 0,
      transform: 'translateX(-30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  logoImage: {
    width: '100%',
    height: '200px',
    borderRadius: '12px',
    objectFit: 'contain',
    marginBottom: '20px',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
  },
  companyName: {
    margin: '10px 0 8px 0',
    padding: '0',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '700',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  companyDesc: {
    fontStyle: 'italic',
    color: '#f0f0f0',
    fontSize: '13px',
    margin: '0',
    fontWeight: '500',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1,
  },
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes fadeInLeft': {
    from: {
      opacity: 0,
      transform: 'translateX(-30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  '@keyframes slideIn': {
    from: {
      opacity: 0,
      transform: 'translate(-50%, -60%)',
    },
    to: {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
    },
  },
  '@global': {
    'body':{
      margin: '0',
      padding: '0',
      minHeight: '100vh',
      fontFamily: '"Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      overflow: 'auto',
      backgroundColor: '#f5f5f5',
    },
    '#root': {
      minHeight: '100vh',
    },
    'input[type="text"]': {
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      fontSize: '15px !important',
    },
    'input[type="password"]': {
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      fontSize: '15px !important',
    },
    'input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 1) inset !important',
      WebkitTextFillColor: '#000 !important',
    },
    'input:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 1) inset !important',
      WebkitTextFillColor: '#000 !important',
    },
  }
}));


const SignIn = ()=> {
  const classes = useStyles();
  const [formValues,formSetValues] = useState({user_name:'',user_password:''});
  const [ajaxReqStatus,ajaxReqStatusSet] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  let userNameRef = React.useRef(null)
  let userPassRef = React.useRef(null)
  const history = useHistory();

  const [institution,institutionSet] = useState(null)
  const [licenseKey,setLicenseKey] = useState('')

  useEffect(()=>{
    axios.get(`${API_URL}/public/get-institution`).then(res=>{
      institutionSet(res.data)
    })
  },[])

  const handleKeyPress = (event) => {
    if (event.key === 'r' && (event.ctrlKey || event.metaKey)) {
      openLicenseKeyModal()
      event.preventDefault();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  function openLicenseKeyModal() {
    document.getElementById('licenseKeyModal').style.display = 'block';
  }

  function closeLicenseKeyPrompt() {
    document.getElementById('licenseKeyModal').style.display = 'none';
  }

  let handleLicenseKey = async (e)=> {
    const getKey = licenseKey;
    setLicenseKey('');

    if(getKey.trim() == ''){
      swal({
        title:'Key is required.',
        icon:'warning'
      })
      return false
    }else{
      await axios.post(`${API_URL}/license-key-checker`,{
        license_key:getKey
      }).then(res=>{
        if(res.data.error == false){
          swal({
            title:`${res.data.message}`,
            icon:'success'
          })
        }else{
          swal({
            title:`${res.data.message}`,
            icon:'warning'
          })
        }
      })
    }
    e.preventDefault()
  }

  const signinAction = async () =>{
    if(formValues.user_name==''){
      swal({
        title:'Username is required.',
        icon:'warning'
      })
    }else if(formValues.user_password==''){
      swal({
        title:'Password is required.',
        icon:'warning'
      })
    }else if(formValues.user_password.length<6){
      swal({
        title:'Password should be minimum 6 characters',
        icon:'warning'
      })
    }else{
      ajaxReqStatusSet(true)
      await axios.post(`${API_URL}/signin`,formValues).then(res=>{
        ajaxReqStatusSet(false)
        if(res.data.error==false){
          sessionStorage.setItem('auth_info',JSON.stringify(res.data));
          window.location.href = `${APP_URL}`
        }else{
          swal({
            title:`${res.data.message}`,
            icon:'warning'
          })
        }
      })
    }
  }

  const handleFromInput = (e)=>{
    const {name,value} = e.target;
    formSetValues({...formValues,[name]:value})
  }

  return (
    <div className={classes.root}>
      <style>{`
        .MuiOutlinedInput-input {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          font-weight: 600 !important;
          font-size: 15px !important;
          background-color: white !important;
        }
        .MuiOutlinedInput-input:focus {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: white !important;
        }
        .MuiOutlinedInput-root:focus-within input {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: white !important;
        }
        .MuiOutlinedInput-root {
          background-color: white !important;
        }
        .MuiOutlinedInput-root:focus-within {
          background-color: white !important;
        }
        input[type="text"] {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: white !important;
        }
        input[type="password"] {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: white !important;
        }
        input {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: white !important;
        }
      `}</style>
      <CssBaseline />
      <div className={classes.container}>
        {/* Logo Section */}
        <div className={classes.logoSection}>
          <img
            alt="Company Logo"
            src={`${API_URL}/uploads/${institution!= null ? institution.pro_logo:''}`}
            className={classes.logoImage}
          />
          <h2 className={classes.companyName}>
            { `${institution!= null ? institution.pro_name:''}` }
          </h2>
          <p className={classes.companyDesc}>
            { `${institution!= null ? institution.pro_desc:''}` }
          </p>
        </div>

        {/* Login Form Section */}
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon style={{fontSize: '40px'}} />
          </Avatar>

          <Typography component="h4" variant="h5" className={classes.title}>
            Welcome Back
          </Typography>
          <Typography className={classes.subtitle}>
            Sign in to your account
          </Typography>

          <Collapse in={open}>
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              style={{marginBottom: '20px'}}
            >
              Oops !! Connection failed.
            </Alert>
          </Collapse>

          <form className={classes.form}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Username"
              name="user_name"
              autoComplete="off"
              inputRef={userNameRef}
              value={formValues.user_name}
              onChange={handleFromInput}
              onKeyDown={event => {
                if (event.key === "Enter") {
                  userPassRef.current.focus()
                }
              }}
              sx={{
                marginBottom: '16px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  '& fieldset': {
                    borderColor: 'rgba(227, 39, 48, 0.2)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(227, 39, 48, 0.5)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#E32730',
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#000000 !important',
                  fontSize: '15px',
                  fontWeight: '600',
                },
                '& .MuiFormLabel-root': {
                  color: '#666',
                  '&.Mui-focused': {
                    color: '#E32730',
                  },
                },
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="user_password"
              label="Password"
              type="password"
              autoComplete="off"
              inputRef={userPassRef}
              value={formValues.user_password}
              onChange={handleFromInput}
              onKeyDown={event => {
                if (event.key === "Enter") {
                  signinAction()
                }
              }}
              sx={{
                marginBottom: '16px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  '& fieldset': {
                    borderColor: 'rgba(227, 39, 48, 0.2)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(227, 39, 48, 0.5)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#E32730',
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#000000 !important',
                  fontSize: '15px',
                  fontWeight: '600',
                },
                '& .MuiFormLabel-root': {
                  color: '#666',
                  '&.Mui-focused': {
                    color: '#E32730',
                  },
                },
              }}
            />

            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={signinAction}
              className={classes.submit}
              disabled={ajaxReqStatus}
            >
              {ajaxReqStatus ? 'Signing In...' : 'Sign In'}
            </Button>
          </form>

          <Copyright />
        </div>
      </div>

      {/* License Key Modal */}
      <div id="licenseKeyModal" className={classes.licenseKeyModal}>
        <h3 style={{marginTop: 0, marginBottom: '20px', color: '#333', fontSize: '18px', fontWeight: '600'}}>
          Enter License Key
        </h3>
        <input
          type="text"
          placeholder="Enter your license key here"
          onFocus={handleFocus}
          style={{
            border: isFocused ? '2px solid #667eea' : '1px solid #ddd',
            padding: '12px 15px',
            borderRadius: '8px',
            transition: 'all 0.3s ease',
            color: '#333',
            width:'100%',
            marginBottom:'15px',
            fontSize: '14px',
            boxSizing: 'border-box',
            boxShadow: isFocused ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : 'none',
          }}
          value={licenseKey}
          onChange={(e) => setLicenseKey(e.target.value)}
          autoComplete="off"
        />
        <br/>
        <button
          onClick={(e) => handleLicenseKey(e)}
          style={{
            padding: '10px 20px',
            marginRight: '8px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          }}
          onMouseEnter={(e) => {
            e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          OK
        </button>
        <button
          onClick={closeLicenseKeyPrompt}
          style={{
            padding: '10px 20px',
            background: '#f0f0f0',
            color: '#333',
            border: '1px solid #ddd',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#e0e0e0';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#f0f0f0';
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default SignIn


